import React from 'react';
import withRoot from './modules/withRoot';
import ListeningGame from './modules/views/ListeningGame';
import { ARTICLE_URL_PATH } from './modules/views/ListeningGame';
import { UI_BASE_URL } from './consts';
import { CssBaseline } from '@mui/material';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';
import { langProps } from './interfaces/types';


const Page = () => (
    <React.Fragment>
        <AppAppBar />
        <ListeningGame
            path={UI_BASE_URL + ARTICLE_URL_PATH}
        />
        <AppFooter />
    </React.Fragment>
);

export default withRoot(Page);
